import BaseMygocuApiService from './BaseMygocuApiService';

const LANDING_PAGE_API_VERSION = 'v1';
const LANDING_PAGE_API_BASEPATH_URL = '/landingPage/' + LANDING_PAGE_API_VERSION;

class LandingPageApiService {
  async getHomepage() {
    return await BaseMygocuApiService.get(LANDING_PAGE_API_BASEPATH_URL.concat('/homepage'));
  }

  async getLandingPage(uri, codigoPrevisualizacion) {
    return await BaseMygocuApiService.get(LANDING_PAGE_API_BASEPATH_URL.concat(`/${uri}`), { codigoPrevisualizacion });
  }

  async getLandingPageBuilderModules(uri, codigoPrevisualizacion) {
    return await BaseMygocuApiService.get(LANDING_PAGE_API_BASEPATH_URL.concat(`/${uri}/builderModules`), {
      codigoPrevisualizacion,
    });
  }

  async guardarLead(uri, leadDTO) {
    return await BaseMygocuApiService.post(LANDING_PAGE_API_BASEPATH_URL.concat(`/${uri}/leads`), leadDTO);
  }
}

export default new LandingPageApiService();
